import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-574a1b97"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "common"
};
const _hoisted_3 = {
  class: "section-top"
};
const _hoisted_4 = {
  class: "list"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "list"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "list"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"right\" data-v-574a1b97><div class=\"line1\" data-v-574a1b97><span class=\"logo-text bak\" data-v-574a1b97></span></div><span class=\"line2\" data-v-574a1b97>深圳市微星物联科技有限公司</span><span class=\"line3\" data-v-574a1b97>地址：深圳市南山区高新南九道45号 西北工业大学三航科技大厦2407</span><div class=\"line4\" data-v-574a1b97><div class=\"left\" data-v-574a1b97><span class=\"text1\" data-v-574a1b97>商务合作</span><span class=\"text2\" data-v-574a1b97>13760682012 张经理</span></div></div></div>", 1);
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "sep"
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-bottom"
}, [/*#__PURE__*/_createTextVNode(" Copyright 2016 - 2023 WSTAIOT. All Rights Reserved "), /*#__PURE__*/_createElementVNode("a", {
  class: "icp-code",
  href: "https://beian.miit.gov.cn/#/Integrated/index"
}, "粤ICP备2023000014号-1")], -1));
import solution from '@/data/solution';
import cases from '@/data/cases';
import deviceMap from '@/views/device-detail/data/product';
import software from '@/data/software';
import service from '@/data/service';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'footer',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const clickNewsItem = index => {
      router.push({
        path: `/news-detail/${index}`
      });
    };
    const linkToMoreNews = () => {
      router.push({
        name: 'news-list'
      });
    };
    const linkToMoreCase = () => {
      router.push({
        name: 'cases'
      });
    };
    const linkToMoreSolution = () => {
      router.push({
        name: 'solution'
      });
    };
    const linkToCaseDetail = index => {
      router.push({
        path: `/cases/${index}`
      });
    };
    const linkToSolutionDetail = id => {
      router.push({
        path: `/solution/${id}`
      });
    };
    const linkToDeviceDetail = id => {
      router.push({
        name: 'device-detail',
        params: {
          id
        }
      });
    };
    const linkToAbout = () => {
      router.push({
        path: `/about`
      });
    };
    const linkToSoftware = id => {
      if (id) {
        router.push({
          path: `/software/${id}`
        });
      } else {
        router.push({
          path: `/software`
        });
      }
    };
    const linkToService = id => {
      if (id) {
        router.push({
          path: `/service/${id}`
        });
      } else {
        router.push({
          path: `/service`
        });
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("ul", _hoisted_4, [_createElementVNode("h3", {
        class: "title",
        onClick: linkToMoreSolution
      }, "解决方案"), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(solution), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "item",
          onClick: $event => linkToSolutionDetail(index)
        }, _toDisplayString(item.title), 9, _hoisted_5);
      }), 128))]), _createElementVNode("ul", _hoisted_6, [_createElementVNode("h3", {
        class: "title",
        onClick: linkToMoreCase
      }, "成功案例"), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cases), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "item",
          onClick: $event => linkToCaseDetail(index)
        }, _toDisplayString(item.title), 9, _hoisted_7);
      }), 128))]), _createElementVNode("ul", _hoisted_8, [_createElementVNode("h3", {
        class: "title",
        onClick: _cache[0] || (_cache[0] = $event => linkToSoftware())
      }, "平台服务"), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(software), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "item",
          onClick: $event => linkToSoftware(index)
        }, _toDisplayString(item.title), 9, _hoisted_9);
      }), 128))]), _createElementVNode("ul", _hoisted_10, [_createElementVNode("h3", {
        class: "title",
        onClick: _cache[1] || (_cache[1] = $event => linkToService())
      }, "软件开发"), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(service), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "item",
          onClick: $event => linkToService(index)
        }, _toDisplayString(item.title), 9, _hoisted_11);
      }), 128))]), _createElementVNode("ul", {
        class: "list"
      }, [_createElementVNode("h3", {
        class: "title",
        onClick: linkToAbout
      }, "关于我们")]), _hoisted_12]), _hoisted_13, _hoisted_14])]);
    };
  }
};